import styled from 'styled-components'
import LeftBar from '../../home/components/leftBar'

import Projetos from './body'
import ReactGA from 'react-ga4'
import SystemStatusBanner from '../../../globalComponents/SystemStatusBanner'

const Page = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden !important;
`

const Content = styled.div`
    display: flex;
    flex: 1;
    overflow: hidden;
`

export default function ProjetosPage() {
    ReactGA.send({
        hitType: 'pageview',
        page: '/projetos',
        title: 'Projects',
    })

    return (
        <Page>
            <SystemStatusBanner />
            <Content>
                <LeftBar />
                <Projetos />
            </Content>
        </Page>
    )
}
